module.exports = __webpack_public_path__ + "img/5_irene_s.0ca7d6b3.png";